import { useParams } from 'react-router-dom';
import CardSign from '../components/card_sign/Card_Sing';
import ShowGroupsSigns from '../components/show_groups_signs/Show_groups_signs'
import {signosValidos} from '../common/constants/signos'

const Horoscopo = () => {
  const { signo } = useParams();

  const signoValido = signo && signosValidos.includes(signo.toLowerCase());

  return (
    <div className="App">
      {signoValido ? (
        <CardSign sign={signo} />
      ) : (
        <ShowGroupsSigns label="horoscopo" />
      )}
    </div>
  );
};

export default Horoscopo;